module.exports = ModulesShared;